import getLanguageByPath from '@src/utils/locale/getLanguageByPath.js';
import mergeLocalesData from '@src/global-locales/utils/merge-locales-data.js';
import getLanguageFolderName from '@src/utils/locale/getLanguageFolderName.js';

const languageFilePath = getLanguageByPath() === 'zh-cn' ? '' : `${getLanguageFolderName()}/`;

/**
 * @name pageLocalesData
 */
const pageLocalesData = {
  global: {
    comming_soon: '敬请期待',
    copiedGoToMobileToOpen: '已复制链接，请前往移动端打开'
  },
  // 通用
  common: {
    login_content: '登录',
    preRegister_login_content: '预约',
    exit_content: '退出'
  },
  cookie: {
    tips: 'The website uses cookies to enhance your browsing experience. <a href="{link}" target="_blank" >Learn more</a>',
    button: 'ok'
  },
  cookieInfo: {
    perference_settings: 'Perference Settings',
    cookie_description:
      'We use necessary cookies to ensure our website functions properly. Additionally, we also wish to employ optional cookies (including those from third-party partners) to enhance your experience and analyze site usage. For more details, please refer to our<a href="{link}" target="_blank" >Cookie Policy</a>.',
    settings_description:
      'Cookies and similar technologies may be used to store or retrieve information during your visit. While cookies are necessary for basic site functions, you can choose to disable certain types. Note that this may impact your experience.',
    necessary_cookies: 'Necessary Cookies',
    necessary_cookies_description: 'Necessary for enabling basic website functionalities, you cannot disable necessary cookies.',
    analytics_cookies: 'Analytics Cookies',
    analytics_cookies_description: '帮助网站运营商了解其网站的运行情况、访问者如何与网站互动以及是否可能存在技术问题。',
    view_details: ' View Details',
    _ga_description: '生成有关访客如何使用我们的服务的统计数据',
    _ga_duration: '1年',
    _ga_x_description: '生成有关访客如何使用我们的服务的统计数据',
    _ga_x_duration: '1年',
    _gid_description: '生成有关访客如何使用我们的服务的统计数据',
    _gid_duration: '1天',
    session_id_description: '保存用户登录状态相关信息',
    session_id_duration: '3小时（有访问会续期）',
    cookie_flag_description: '用于保存用户cookie设置状态',
    cookie_flag_duration: '90天',
    label_name: '名称',
    label_provider: '提供者',
    label_duration: '持续时间',
    label_description: '说明',
    confirm_btn: 'Confirm',
    allow_all_btn: 'allowAll',
    cookie_setting_btn: 'cookie设置',
    reject_all_cookies: '拒绝所有的cookies',
    allow_all_cookies: '接受所有的cookie'
  },
  navbar: {
    home: '首页',
    news: '新闻资讯',
    games_introduction: '游戏介绍',
    game_play: '游戏玩法',
    mecha: '机兵介绍',
    combat_information: '作战资料',
    msmk_raiders: '玛什马克攻略战',
    map3v3: '3V3地图',
    map: '6V6地图',
    world_view: '世界观',
    FAQ: 'FAQ',
    activity_zone: '活动专区',
    creator_progam: '创作者活动',
    twitch_drop: 'TwitchDrop',
    pack_center: '礼包中心',
    collectors_pack: '特装机典藏版',
    premium_games: '精品游戏',
    more_game: '更多游戏',
    official_tool: '官方工具',
    customer_service: '用户服务',
    know_us: '了解我们',
    join_us: '加入我们',
    listOfAppearances: '造型排行榜',
    callCenter: '客服中心',
    pioneerTeamActivity: '先驱小队活动',
    download: '下载游戏',
    storm_plan: '风暴计划',
    styleRanking: '造型排行',
    surrounding: '周边商城',
    valueCenter: '储值中心',
    mechaUnitList: '王牌档案',
    wallpaper: '壁纸'
  },
  common_footer: {
    privacy_policy: '隐私政策',
    terms_of_service: '服务条款',
    all_rights: 'SEASUN GAMES PTE. LTD. All rights reserved.',
    cookie_agreement: 'cookie协议',
    cookie_setting: 'cookie设定',
    privacy_agreement: '隐私权政策',
    right_of_useAgreement: '使用权协议',
    official_tool: '官方工具',
    game_launcher: '启动器',
    customer_service: '用户服务',
    personal_center: '个人中心',
    reCharge_center: '充值中心',
    know_us: '了解我们',
    about_seasun: '关于西山居',
    followUs: '关注我们',
    community: 'Community: contact@seasungames.com',
    support_partner: 'Support & Partnership: bd@seasungames.com',
    join_us: '加入我们',
    careers: '招聘官网',
    corporation: '成都西山居世游科技有限公司 版权所有',
    copyright_btn: '版权信息',
    purchase: '',
    funds_ja: '',
    acquisition_ja: '',
    zh_text: ''
  },
  // 预约
  reserve: {
    button: '立即预约',
    gift_button: '预约有礼',
    success: {
      title: '已注册',
      tips: 'Follow us for more updates',
      btnConfirm: '确定'
    },
    form: {
      phone: '手机号',
      email: '邮箱',
      vcode: '验证码',
      get_code: '[获取验证码]',
      resend: '重新发送'
    },
    logic: {
      need_agreement: '请先勾选同意隐私条款',
      need_email: '请输入邮箱账号',
      need_phone: '请输入手机号',
      need_vcode: '请输入验证码',
      has_success: '已预约成功',
      auto_close: '{second}（s）后自动关闭',
      phone_format: '请输入正确的手机号码',
      email_format: '请输入正确的邮箱',
      vcode_countdown: '{countdown}（s）后重试'
    },
    agreement: {
      agreement1: '《西山居用户协议》',
      agreementLink1: 'www.baidu.com',
      agreement2: '《西山居用户个人用户信息及隐私保护政策》',
      agreementLink2: 'www.baidu.com',
      desc: '我已阅读并同意<a t href="//{arg1Link}" target="_blank">{arg1}<a/><a href="//{arg2Link}" target="_blank">{arg2}<a/>'
    }
  },
  // 礼包领取弹窗
  gift: {
    cdkCode_modal_title: '领取礼包码',
    copy_btn_text: '复制',
    pickUp_location_tips_text: '请前往游戏内XXX处输入礼包兑换码进行兑换',
    claim_limit_tips_text: '*每位用户仅限兑换一次',
    claim_rewards_btn_text: '领取奖励',
    copy_success_tips_text: '复制成功',
    copy_error_tips_text: '拷贝失败'
  },

  // 首页
  main: {
    kvScreen: {
      downloadText: '下载游戏',
      appointmentText: '预约游戏',
      steamWishBtnText: '添加到Steam愿望单',
      xboxWishBtnText: '添加到Xbox愿望单',
      preRegisterTips: '您已预约'
    },
    wordScreen: {
      nextText: 'Next'
    }
  },

  // 特装详情
  mechaUnit: {
    voiceTabCH: '中文',
    voiceTabEN: '英语',
    voiceTabJA: '日语',
    basicInfoTitle: '基础信息',
    roleExperSubTitle: '角色经历',
    driverVoiceTitle: '驾驶员语音',
    mechaStorySubTitle: '机体背景',
    falcon: {
      driverName: '莱奥妮·菲尔',
      driverType: '矛隼特装型驾驶员',
      driversSex: '性别：女',
      driversBirthplace: '出生地：希古尼亚联合体 赫罗兰王国',
      driversStructure: '搭乘机体：矛隼特装型',
      driversRoleExperText:
        '在媒体的聚光灯下，莱奥妮·菲尔始终有着不少头衔：联合体的首批人造奇迹之子，皇家飞行大队的驾驶员，更是今天的环海能源的年轻董事长。但鲜有人知的是她的另一个身份——S.H.A.D.O.W.行动队的矛隼驾驶员。也许从父亲死于意外的那刻开始，莱奥妮命运的齿轮就已经拨动了：她放弃学业亲历边境地区，冲破来自集团内的重重干预追查父亲的遇害真相，一度濒临危情却为边境路网搭救，在与这一众人的相处中，她逐渐理解认同了父亲所追求的济世理念。在边境路网的相助下，莱奥妮以身设局成功夺回一切，揪出内鬼，粉碎了他们企图扭曲整个集团的阴谋。如今的莱奥妮早已习惯了董事长与驾驶员的身份切换：驾驶矛隼时的她毫无身份包袱，履行小队的行动方针，完美担当着侦察与掠袭的前锋角色......也许这种切身的行动力才是她内在之所以强大的由来。',
      mechaInfoType: '矛隼 特装型',
      manufacturer: '生产商：比弗罗斯特工业集团',
      mechaInfoNums: '机体编号：UBP-R02C',
      mechaInfoHeadHigh: '头顶高：14.7米',
      mechaInfoEmptyWeight: '空重：13.8吨',
      mechaInfoTotal: '全重：16.1吨',
      mechaInfoStory:
        '这台机兵是“瓦尔文”项目引入意识投影技术后生产的第六台原型机，被用作联合体各类新型传感器的测试平台，态势感知能力显著优于其他原型机。参与测试的军方人士建议基于该机开发专用侦察型号，备受喜爱的“矛隼”应运而生——它的进攻性武装少于标准型号，但配备了更加优秀的级联引擎和传感器。“矛隼”顺利量产后该机功成身退，被橡树生命的脑科学研究部门购得，用于探索意识投影技术的性能边界。据说该机在某次例行测试中遭遇EIC灾害并失联，疑似已被EIC侵蚀控制，沦落为“幽灵机兵”的一员。直到数年后，这台机体随S.H.A.D.O.W.行动队高调亮相，相关人士才恍然明白当年对外宣称的“意外”大有门道。',
      manufacturerGruopCh: '比弗罗斯特工业集团',
      cvCH: '黄莺',
      cvEN: 'Ali  Hillis',
      cvJA: '小清水亚美',
      voice: {
        title1: '莱奥妮·菲尔！矛隼驾驶员，很高兴认识你，祝我们合作愉快！',
        title2: '该我和矛隼上阵了么。',
        title3: '胜利之光与矛隼共舞！'
      }
    },
    feijing: {
      driverName: '014',
      driverType: '飞景改装型驾驶员',
      driversSex: '性别：男',
      driversBirthplace: '出生地：罗迦共和国',
      driversStructure: '搭乘机体：飞景改装型',
      driversRoleExperText:
        '014这个编号是他的名字，作为战争机器诞生于培养舱，时任风标航运高层的父亲阿德里安还给了他另外的名字“陆回”。阿德里安的孩子陆回，从一出生就被训练成绝对忠诚于风标航运的战斗者，好在母亲的陪伴使得他黑暗的童年有了光亮。母亲不知去了哪里，成年后他奉阿德里安之命潜入薪火重工盗取“飞景”机兵数据时，一直在寻找母亲的下落。然而在薪火重工，他没料到会遇见众多战友，教会了战争机器何为战友的温度。陆回从阿德里安的掌控中叛逃。在风标航运，阿德里安的“女王蜂”计划正在进行。“女王蜂”连接着杀戮机器，那就是陆回的克隆人们，014是其中之一。014为父亲执行任务，以为自己是陆回，当他发现真相、当陆回把“飞景”交给他时，钢铁羽翼下他明白了存在的意义。014与陆回联手摧毁“女王蜂”，沉重打击风标航运和阿德里安的阴谋，也终于让母亲解脱。',
      mechaInfoType: '飞景 改装型',
      manufacturer: '生产商：薪火重工',
      mechaInfoNums: '机体编号：PGI-T27G3',
      mechaInfoHeadHigh: '头顶高：16.6 米',
      mechaInfoEmptyWeight: '空重：17.2 吨',
      mechaInfoTotal: '全重：23.3 吨',
      mechaInfoStory: '占位，目前文案没定',
      manufacturerGruopCh: '薪火重工',
      cvCH: '马洋',
      cvEN: 'Griffin Puatu',
      cvJA: '千叶翔也',
      voice: {
        title1: '014，战前准备完成，随时出发。',
        title2: ' 014报道，你可以称我陆回。',
        title3: '感受到杀机了么，飞景在靠近。'
      }
    },
    baihong: {
      driverName: '吉娜',
      driverType: '白虹特装型驾驶员',
      driversSex: '性别：女',
      driversBirthplace: '出生地：月海共同体',
      driversStructure: '搭乘机体：白虹特装型',
      driversRoleExperText:
        '吉娜是月球地球最有人气的歌星，也是背负血仇的机甲战士。吉娜的歌声曾抚慰过无数移民月球却生活在底层的“后来者”，而现在她驾驶着"白虹"正穿梭于弹火之中。年少时与父亲哥哥分开，和母亲在月面大都市生活，18岁横跨地月成为超级巨星时，却不知父亲凯恩早已暗中领导着月球底层反抗组织"特伊亚"。命运的转折始于一场巡演，当她在反抗军基地与父亲重逢，目睹人们的艰辛与困苦，目睹父亲向贫民窟鞠躬，吉娜的音乐开始染上抗争的血色。太空电梯落成典礼本该是她又一次艺术巅峰，崩塌的太空电梯碎片却夺去了数十万生命，袭击者竟是高喊着"革命需要牺牲"的亲哥哥。父亲倒在哥哥的枪响下，昔日温柔的兄长已成恶魔，操控着更名"特伊亚战线"的武装集团对地月进行暴力打击。而今吉娜成为S.H.A.D.O.W.行动队的一员，“白虹”摧毁阴谋时，驾驶舱里永远循环着那首未完成的安魂曲，紧握操纵杆的吉娜说道："我只想亲眼看着哥哥戴上镣铐。"',
      mechaInfoType: '白虹 特装型',
      manufacturer: '生产商：摩诃重工',
      mechaInfoNums: '机体编号：MHI-SR00',
      mechaInfoHeadHigh: '头顶高：16.2 米',
      mechaInfoEmptyWeight: '空重：19.9 吨',
      mechaInfoTotal: '全重：22.8 吨',
      mechaInfoStory:
        '这台“白虹”是摩诃重工生产的第一台意识投影型机兵，与“龙渊”同源，均为同盟开发意识投影的技术原型之一。边境战争后期，月海共同体以慷慨的援助诱使兀廷联邦共和国脱离同盟加入月球阵营，借此获得了意识投影技术和这台原型机。月球当局曾试图以该机先进的电子战系统引导卫星炮，一举歼灭月面反抗组织“特伊亚”，却不料该机反被对方俘获，计划也随之泄露。特伊亚受此事刺激行事日益激进，稳健派领袖被迫驾驶本机保护追随者逃离组织。该机加入S.H.A.D.O.W.行动队后，薪火重工扬其所长，为其配备了一架重型炮击无人机，从战场上空降下垂直狙击扫除该机指示的敌人。',
      manufacturerGruopCh: '摩诃重工',
      cvCH: '陶典',
      cvEN: 'TBD',
      cvJA: '内田真礼',
      voice: {
        title1: '吉娜，嗯~是我，唱歌舞蹈我擅长，但是驾驶机兵我还要跟大家好好学习。',
        title2: ' 和你待在一起，我总有很多创作灵感~',
        title3: '我会驾驶白虹歌唱，带给世界希望！'
      }
    },
    narukami: {
      driverName: '神谷花音',
      driverType: '鸣神 特式 驾驶员',
      driversSex: '性别：女',
      driversBirthplace: '出生地：羽州国',
      driversStructure: '搭乘机体：鸣神 特式',
      driversRoleExperText:
        '直到最近，神谷花音才终于习惯这个新名字。这位温婉端庄的大小姐是神谷财团派驻S.H.A.D.O.W.行动队的代表，她和她的机兵“鸣神”象征着神谷家族对边境路网无保留的支持与信任——这些当然只是外交辞令。只有少数人知道，两年前花音是孤身逃离封闭的岛舰，那时被强加的“神谷”之名是束缚着她的最后一条枷锁。加入S.H.A.D.O.W.行动队是花音第一次离开和平的家乡。那时她虽有两千次模拟战击坠但缺乏实战经验、温柔隐忍的性格似乎也不适合残酷的战场，难免引来许多风言风语。但这只持续到她的第一次任务——她和她的“鸣神”展现了超乎想象的娴熟……和冷漠，精准的狙击没有一丝犹豫。花音的奇妙反差并非无迹可寻，与她相熟之后其实不难发现她隐藏在优雅笑容下的“本性”：热衷练枪、擅长吵架、喜欢画漫画、讨厌神谷家……',
      mechaInfoType: '鸣神 特式',
      manufacturer: '生产商：神谷重工',
      mechaInfoNums: '机体编号：KMA-D201S',
      mechaInfoHeadHigh: '头顶高：14.8 米',
      mechaInfoEmptyWeight: '空重：17.2 吨',
      mechaInfoTotal: '全重：20.9 吨',
      mechaInfoStory:
        '神谷花音的爱机是“鸣神”的第一台原型机。该机贵为羽州首台意识投影型机兵，肩负着为岛舰测试意识投影技术的重任。这位神谷家“大小姐”受命运引导登上并启动了“鸣神”，却又巧妙借助“鸣神”的力量一举逃离牢笼，挣脱了命运的操弄。花音携机加入本队之后，薪火重工不仅将她的机兵升级至解限型规格，还以之作为超微成像单元“星尘”的测试平台，验证了光学迷彩、质量投影等奇妙的电子战装备。依照协议，这台“鸣神”的战斗和测试数据均会回传神谷家，作为花音拥抱自由的交换条件。花音隐匿于光学迷彩之下射落对手时，或许也会回想起她初次坐进驾驶舱的那个遥远下午。',
      manufacturerGruopCh: '神谷重工',
      cvCH: '张琦',
      cvEN: 'Erika Harlacher-Stone',
      cvJA: '花守由美里',
      voice: {
        title1: '我叫神谷花音，请多指教。总算正式见面了，我听过很多有关你的故事，可以告诉我更多吗。',
        title2: '该去刷新鸣神的战绩了。',
        title3: '扣动扳机即分胜负，这就是鸣神。'
      }
    },
    welkin: {
      driverName: '向蕊',
      driverType: '赤霄 特装型 驾驶员',
      driversSex: '性别：女',
      driversBirthplace: '出生地：沃图里亚战略同盟 玉梁',
      driversStructure: '搭乘机体：赤霄 特装型',
      driversRoleExperText:
        '很多S.H.A.D.O.W.的同僚会因为苍绿的发色注意到可爱的向蕊，但见识过驾驶赤霄的她如旋风般席卷战场后，这个印象却又被完全颠覆。向蕊是整备班的常客，在机械领域有过人理解的她甚至能用几台报废机体重组出一台能动的机兵，这都要归功于她自幼就跟随机械师父亲漂泊的那些日积月累。如果当初父女的行踪没有被风标航运发现，现在的她可能还过着无拘无束的日子，可现实降予她的却是带着父亲托付的密件，独自驾驶残破机体对抗风标航运的追兵，辗转逃亡......直到向蕊成功接触边境路网，她才知晓自己保全的密件竞是足以改变世界格局的机兵技术。如今的向蕊时刻都充满着活力，即使驾驶赤霄作战时也同样自由奔放，积极乐观的战斗态度总能鼓舞到协同出击的队友，或许她早已将过去在逆境中的积累化作了今后前进的动力。',
      mechaInfoType: '赤霄 特装型',
      manufacturer: '生产商：薪火重工',
      mechaInfoNums: '机体编号：PGI-T02C',
      mechaInfoHeadHigh: '头顶高：15.7 米',
      mechaInfoEmptyWeight: '空重：31.2 吨',
      mechaInfoTotal: '全重：40.1 吨',
      mechaInfoStory:
        '向蕊视若至宝的这台“赤霄”是对S.H.A.D.O.W.行动队也意义非凡的重要机兵。它曾只是欧冶电科流水线上一台平平无奇的战争机器，将以“武人”之名为同盟克敌制胜。然而，未来学会与薪火重工相继成立，同盟将这台尚未完工的机兵选为赠予未来学会的出生礼，寄望它能为褪色危机阴霾下的世界开辟未来。薪火重工接手该机的后续建造，为其搭载了尚在工程原型阶段的解限型意识投影系统。很长一段时日，本机都在未来学会麾下测试各类用于褪色区探索的特种防护装备，直到某日一位少女携着父亲的遗物前来拜访未来学会。其父留下的研究资料成就了本机最具代表性的力场武装，少女也凭从其柔弱外表难以想象的坚韧意志突破层层考核加入S.H.A.D.O.W.行动队成为驾驶员，如愿乘上这台承载着父亲心血与遗念的强大机兵。',
      manufacturerGruopCh: '薪火重工',
      cvCH: '陈奕雯',
      cvEN: 'Xanthe Huynh',
      cvJA: '古贺葵',
      voice: {
        title1: '向蕊～记住不要读错了哦~别看我个子小，我就是开背后这台大块头的！流浪车队的那些孩子都得叫我姐姐。',
        title2: '来了来了！是有机械零件要给我吗？',
        title3: '赤霄，是爸爸留下的希望之光！'
      }
    },
    tricera: {
      driverName: '查尔斯·贝尔',
      driverType: '三角龙 特装型 驾驶员',
      driversSex: '性别：男',
      driversBirthplace: '出生地：环塔拉萨洋联邦 柯斯托克',
      driversStructure: '搭乘机体：三角龙 特装型',
      driversRoleExperText:
        '如果问起对查尔斯·贝尔的第一印象，S.H.A.D.O.W.行动队全员想必都会回答“老兵”。这位经验丰富的驾驶员早在大灾难前就在柯斯托克陆军服役，是队中最受信赖的前线指挥，也是最受畏惧的魔鬼教官。入队伊始，查尔斯也曾尝试维持威严冷峻的硬汉形象，可惜他收养的孩子们不断寄来涂鸦、布偶、木雕和护身符，总让他没办法藏起笑意。他很少提起，这些孩子们曾和他一起经营餐厅，生活艰苦却也温馨；他绝不会忘记，养女安卡的“奇迹之子”能力遭人觊觎，他的家乡因此被佣兵夷为平地。此事令查尔斯决心重回战场——即使这意味着他只能将孩子们送入掩体城市接受组织庇护，无法陪伴他们成长。近来要强的安卡也追随查尔斯入了队，这令他时不时就会被队员半开玩笑地叫作“岳父”。如今安卡仍是他最担心的孩子，不过担心的内容显然有所变化……',
      mechaInfoType: '三角龙 特装型',
      manufacturer: '生产商：萨勒姆电气',
      mechaInfoNums: '机体编号：SLM-X324C',
      mechaInfoHeadHigh: '头顶高：17.3 米',
      mechaInfoEmptyWeight: '空重：41.5 吨',
      mechaInfoTotal: '全重：54.5 吨',
      mechaInfoStory:
        '老兵查尔斯的爱机“三角龙”原本属于二代机兵“恐龙”的极初期生产批次，早在南部战争期间就已服役。查尔斯携机加入边境路网时不少同僚猜测他会换乘新锐的“雷龙”，他却选择说服薪火重工将他的老搭档升级至解限型规格。薪火重工推出的一揽子升级方案以查尔斯爱机的昵称“三角龙”命名，囊括了解限系统和与之匹配的传感器、聚合物肌肉，还引入战术变形机能，令该机可以定点驻扎展开为重甲炮台。“三角龙”足以对抗最先进的解限型机兵，业已被视为旧型机升级的标杆之作。现时各方保有的“恐龙”超过三千台，已有多个组织斥资引进“三角龙”改装，令薪火重工一举跻身头部厂商的行列。',
      manufacturerGruopCh: '萨勒姆电气',
      cvCH: '刘以嘉',
      cvEN: 'Robbie Daymond',
      cvJA: '小山力也',
      voice: {
        title1: '查尔斯·贝尔中校！前来报道！突然把我从边境路网转调到这里，一定是有要紧的任务吧，期待组织的安排。。',
        title2: '说吧，什么时候出击。',
        title3: '三角龙就是守护者的象征！'
      }
    },
    inferno: {
      driverName: '赛迪莱妮',
      driverType: '地狱火 试验型 驾驶员',
      driversSex: '性别：女',
      driversBirthplace: '出生地：兀廷联邦共和国',
      driversStructure: '搭乘机体：地狱火 试验型',
      driversRoleExperText:
        '赛迪莱妮是S.H.A.D.O.W.行动队最神秘的驾驶员，没有之一。多数队员对她的了解仅限于“赛迪莱妮”并非本名而是行动代号，即使是八面玲珑、消息灵通的琪娅拉，也仅仅比别人多知道一条从队医那儿打听来的“她是强化人”。当然“神秘感”的主因之一是她精神不稳定令人很难接近，但根源还是在于她失去了记忆。名字、经历、情谊、梦想——她脑中的一切早已因强化人改造的副作用支离破碎，求助于最好的医生也无从挽回。不过，近来赛迪莱妮与来自岛舰的狙击手花音相处融洽，她不但醉心于花音绘制的漫画，有时还会向花音展示她那些后现代风格的蜡笔涂鸦，仿佛将花音的身影与某位重要的人重叠。按照花音的说法，那些涂鸦最常见的主题是“姐姐”和“爸爸”，或许赛迪莱妮在惨遭改造之前也曾拥有一个温馨幸福的家。',
      mechaInfoType: '地狱火 试验型',
      manufacturer: '生产商：萨勒姆电气',
      mechaInfoNums: '机体编号：SLM-X143-2',
      mechaInfoHeadHigh: '头顶高：17.3 米',
      mechaInfoEmptyWeight: '空重：41.5 吨',
      mechaInfoTotal: '全重：54.6 吨',
      mechaInfoStory:
        '这台“地狱火”与世人熟知的量产型号有很大不同，狰狞的装甲轮廓与它的驾驶员一样令人望而生畏。在被S.H.A.D.O.W.行动队收编之前，该机曾是巨企“风标航运”旗下最凶狠的斗犬之一，仅仅一年就踏遍全球战场、击坠无数久经沙场的对手，不少有头有脸的驾驶员都曾是它的手下败将，甚至有人将它视为天灾的化身唯恐避之不及。该机入队时曾在队内引发很大争议，许多人担忧接纳这台风标航运的名机会败坏组织来之不易的好名声。好在到头来还是认为“关键不在兵器，而在是谁使用兵器”的声音占了上风，行动队决定接纳这台机兵和它的主人。尽管至今仍有队员心存疑虑，但这台凶悍的机兵早已赢取了更多人的信赖。',
      manufacturerGruopCh: '萨勒姆电气',
      cvCH: '佟心竹',
      cvEN: 'Emi Lo',
      cvJA: '小林优',
      voice: {
        title1: '我叫赛迪莱妮。只要让我上前线就可以，只有最前线能让我兴奋，哈哈哈，你懂吗？',
        title2: '我闻到了战火的焦味儿。',
        title3: '哈哈哈，真是杰作啊，地狱火。'
      }
    },
    luminae: {
      driverName: '夏莉',
      driverType: '卢米纳尔 特装型 驾驶员',
      driversSex: '性别：女',
      driversBirthplace: '出生地：沃图里亚战略同盟 济安',
      driversStructure: '搭乘机体：卢米纳尔 特装型',
      driversRoleExperText:
        '在没有出击任务的时候，夏莉也不会闲下来，她会到机库协助整备班进行维修。这是她当年带着妹妹在边境地区追随救助队期间学到的技艺。因此，作为“机械达人”的向蕊也将她视作交流的好友。 夏莉温暖的笑容之下，是她如今必须依靠义肢才能行走的现实。边境战争让她失去了双腿，但她不愿被怜悯，无需任何人“照顾”自己，她会像过去那样生活。当年的袭击过后，救援队并未在废墟中找到夏莉，她一度被认定为失踪，直至数月前，夏莉才终于被肆处奔走、坚信自己还活着的妹妹带回边境路网。期间她在阿尔伯特机关的遭遇，令她的记忆有了损伤，她始终无法连贯地回想起这些年的所有经历。不过她并未对此过于苦恼，在她看来，比起曾经被“灌输”的那些虚假记忆，至少她现在找回了真正的家人与自己。',
      mechaInfoType: '卢米纳尔 特装型',
      manufacturer: '生产商：诺格月球公司',
      mechaInfoNums: '机体编号：NGL-SR30',
      mechaInfoHeadHigh: '头顶高：15.7米',
      mechaInfoEmptyWeight: '空重：19.8 吨',
      mechaInfoTotal: '全重：23.1 吨',
      mechaInfoStory:
        '这台机兵是“卢米纳尔”开发阶段建造的原型机之一。它在建造之初仅是一台乏善可陈的工程用二代机兵，但月海共同体经兀廷渠道获得解限型机兵原型“白虹”后惊觉新时代已然迫近，紧急要求诺格月球公司将在研的“卢米纳尔”修改为解限型机兵。这台机兵因此加装了彼时尚不成熟的解限型意识投影系统，为日后的一系列“意外”埋下了隐患。类似于同时期的其他测试原型，该机缺乏对驾驶员的必要保护。驾驶员的心智经解限系统介导，向周遭环境完全开放。极度敏锐的感官将超量信息传入大脑，会对驾驶员造成严重的精神负荷。不知是幸运还是不幸，当前的驾驶员早已适应这台危险机体，远超他人的长期磨合让这台“支援机”在她手中成为令人胆寒的强敌。',
      manufacturerGruopCh: '诺格月球公司',
      cvCH: '陈婷婷',
      cvEN: 'Erica Luttrell',
      cvJA: '菲鲁兹·蓝',
      voice: {
        title1: '你好！放心，卢米纳尔在，一切安全~',
        title2: '我的修理机器人好用吗？哼~',
        title3: '是我，卢米纳尔制胜全场！'
      }
    },
    panther: {
      driverName: '沃纳·恩斯特',
      driverType: '黑豹 特装型 驾驶员',
      driversSex: '性别：男',
      driversBirthplace: '出生地：希古尼亚联合体 穆斯佩尔海姆王国',
      driversStructure: '搭乘机体：黑豹 特装型',
      driversRoleExperText:
        '自加入S.H.A.D.O.W.起，沃纳·恩斯特一直是公认的最难以接近的驾驶员之一。他总是游离于众人之外独自沉思，除了必要的作战交流外几乎不与他人攀谈，只有他的旧识才知道，过去的他并非如此。他曾是人人称赞的模范贵族青年，家族的骄傲，堂弟最喜爱的“骑士”；也是拥有众多追随者的领袖，意气风发的精英驾驶员。边境战争时期，沃纳因打击军火走私惹上冥河防务。他与堂弟克劳斯执行任务时陷入对方陷阱：地下城爆炸导致克劳斯失联、平民死伤，沃纳因“指挥失误”被军事法庭审判。服刑结束后，他担心牵连家人而选择独自流亡边境，一边寻找冥河防务陷害自己的证据，一边打探堂弟克劳斯下落。几经辗转，他总算找到克劳斯，二人带领民兵组织“瓦哈特”在边境当地立足。为保护他们，沃纳又化名“贝恩”进入冥河防务，以“孤狼”之名蛰伏。他在黑暗中守护微光，虽然尚未想清骑士之道能否解决乱世争端，却始终践行“只为守护弱者拔剑”的誓言。',
      mechaInfoType: '黑豹 特装型',
      manufacturer: '生产商：比弗罗斯特工业集团',
      mechaInfoNums: '机体编号：UBP-A04C',
      mechaInfoHeadHigh: '头顶高：16.7米',
      mechaInfoEmptyWeight: '空重：23.5 吨',
      mechaInfoTotal: '全重：29.9 吨',
      mechaInfoStory:
        '这台“地狱火”与世人熟知的量产型号有很大不同，狰狞的装甲轮廓与它的驾驶员一样令人望而生畏。在被S.H.A.D.O.W.行动队收编之前，该机曾是巨企“风标航运”旗下最凶狠的斗犬之一，仅仅一年就踏遍全球战场、击坠无数久经沙场的对手，不少有头有脸的驾驶员都曾是它的手下败将，甚至有人将它视为天灾的化身唯恐避之不及。该机入队时曾在队内引发很大争议，许多人担忧接纳这台风标航运的名机会败坏组织来之不易的好名声。好在到头来还是认为“关键不在兵器，而在是谁使用兵器”的声音占了上风，行动队决定接纳这台机兵和它的主人。尽管至今仍有队员心存疑虑，但这台凶悍的机兵早已赢取了更多人的信赖。',
      manufacturerGruopCh: '比弗罗斯特工业集团',
      cvCH: '李嘉祥',
      cvEN: 'Daman Mills',
      cvJA: '梅原裕一郎',
      voice: {
        title1: '我就是沃纳·恩斯特，呵，S.H.A.D.O.W.这名头倒是与我非常相配。',
        title2: '这次是要正面交锋么？',
        title3: '黑豹会信守保护弱者的承诺！'
      }
    },
    alpha: {
      driverName: '琪娅拉·墨菲',
      driverType: '阿尔法 改装型 驾驶员',
      driversSex: '性别：女',
      driversBirthplace: '出生地：希古尼亚联合体 密斯共和国',
      driversStructure: '搭乘机体：NGS-X241A1阿尔法改装型',
      driversRoleExperText:
        '“姐姐说过，我的笑容就是她的归处。”五年前，战火夺走了琪娅拉相依为命的姐姐。那之后的无数个夜晚，她总会梦到姐妹俩随商队流浪时的生活——姐姐帮人们维修电器，她偎在姐姐身旁与顾客聊天，以笑容向他们换取故事，又用故事为姐姐招揽生意，艰辛却也温馨的旅途仿佛将永远持续。那之后的无数个清晨，她总会流着泪醒来，地面崩塌时姐姐的手滑脱前那最后一缕温暖似乎从未消散。正是姐姐失踪的那一天，琪娅拉在狼藉中听见了EIC的呼唤，却也遭到褪色病的感染。她不止一次试图擦去在肌肤表面扩散生长的异样结晶，但仅凭这样当然无法阻止感染的蔓延。她的身体日渐变得如石像般坚硬，余生恐怕只能在未来学会的医疗舱中度过。有人想帮助她，也有人想利用她。置身善意与恶意交杂的洪流中，这位曾经柔弱的女孩主动提出配合学会的实验，不仅迅速适应了现在这具钢铁的义体，还获允驾驭一台独特的机兵，拥有了找寻姐姐的力量。幼时的她从未想过自己会成为机兵驾驶员，但她的笑颜仍和那时一样没有半点儿阴霾。她知道，即使姐姐认不出妹妹的新身体，也一定会记得妹妹的笑容。',
      mechaInfoType: '阿尔法 改装型',
      manufacturer: '生产商：诺格系统公司',
      mechaInfoNums: '机体编号：NGS-X241A1',
      mechaInfoHeadHigh: '头顶高：16.4米',
      mechaInfoEmptyWeight: '空重：20.6吨',
      mechaInfoTotal: '全重：30.4吨',
      mechaInfoStory:
        '这台独一无二的“阿尔法”来历颇为复杂。它原本隶属联邦陆战队，在一次零重力环境的演习任务中，该机的自动驾驶系统突发故障，以无人驾驶状态冲出演习宙域，消失在宇宙深处。联邦方面搜索未果，只得判定该机在行动中失踪，殊不知此次故障实为月球间谍的手笔，这台机兵已在延时触发的预设指令控制下抵达预定宙域，被月球的接应人员成功回收。月球方面极为忌惮适合在太空作战的“阿尔法”，安排大量人手分析这台机兵。评估完成后，这台失去价值的机兵被未来学会经雨海学社的渠道低价购得。未来学会将该机的作战电脑换为一台在边境战争期间被EIC“污染”的旧型C脑，交予一位和这台机体同样经历坎坷的测试驾驶员。小道消息说，那台旧型C脑来自她从前的机兵，似乎与她有着千丝万缕的隐秘联系。',
      manufacturerGruopCh: '诺格系统公司',
      cvCH: '谢莹',
      cvEN: 'Piper Reese',
      cvJA: '桑原由気',
      voice: {
        title1: '咱可是S.H.A.D.O.W.的秘密武器哦！',
        title2: '这就是阿尔法的真正实力！',
        title3: '阿尔法可不只是飞的够快！'
      }
    }
  },

  // 下载页
  download: {
    FQA: ['关于显卡驱动版本过低问题的解决方案', '关于英特尔CPU问题的解决方案', '《解限机游戏禁止/不建议使用的软硬件列表》']
  }
};

export default mergeLocalesData(pageLocalesData);
